import classes from "./Default.module.css";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { useEffect } from "react";
import { useAuth } from "context/AuthContext";
import applicationUsageLog from "utils/applicationUsagesLog";

const Default = (props) => {
  const { roles, isLoaded } = useAuth();

  useEffect(() => {
    let cancelled = false;

    localStorage.setItem("OBTInfo", window.location.pathname);

    const validateAccess = async () => {
      if (!isLoaded) return;

      if (cancelled) return;

      if (roles.length === 0) {
        window.location.href = "/";
        return;
      }

      window.localStorage.removeItem("OBTInfo");

      if (!cancelled) {
        applicationUsageLog(
          localStorage.getItem("User"),
          localStorage.getItem("EmailId"),
          "CenterPoint",
          "CenterPoint Home",
        );
      }
    };

    validateAccess();

    return () => {
      cancelled = true;
    };
  }, [roles, isLoaded]);

  return (
    <>
      <div className={classes.welcomeOuterContainer}>
        <Card>
          <CardContent className={classes.welcomeContainer}>
            <p className={classes.welcomeText}>
              {" "}
              Welcome {localStorage.getItem("User")} !
            </p>
          </CardContent>
        </Card>
      </div>

      <div className={`${props.className} ${classes.container}`}>
        <p className={classes.text}> To begin, click any icon from left menu</p>
      </div>
    </>
  );
};

export default Default;
